function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  className: "checkmark-in-circle",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 15,
  cy: 15,
  r: 14.5,
  fill: "#FFF",
  stroke: "#CCC"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EDEDED",
  d: "M13.0375175,21.9374325 C12.7375275,21.9374325 12.4375475,21.7874125 12.2875175,21.6373825 L7.3375075,16.6874325 C6.8874975,16.2374225 6.8874975,15.4874225 7.3375075,15.0374125 C7.7875175,14.5874625 8.5375175,14.5874625 8.9875275,15.0374125 L13.1875475,19.2374225 L23.0875375,9.3374625 C23.5375475,8.8875125 24.2875475,8.8875125 24.7375275,9.3374625 C25.1875475,9.7874125 25.1875475,10.5374125 24.7375275,10.9874225 L13.9375475,21.7874125 C13.4875275,21.7873525 13.1875475,21.9374325 13.0375175,21.9374325 Z"
}));

function SvgIconCheckmarkInCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckmarkInCircle);
export default __webpack_public_path__ + "static/media/icon_checkmark_in_circle.5ccd3baa.svg";
export { ForwardRef as ReactComponent };